import { combineReducers } from 'redux';
import user from './user.reducer';
import scheduler from './schedulers';

export const reducer = combineReducers({
  user,
  scheduler
});

export default reducer;